import React, { useState, useEffect } from "react";
import { REQUEST_URL } from "../../config/urls";

const WEBLOJA_API_KEY = process.env.REACT_APP_WEBLOJA_API_KEY || "";

function formatarMoeda(valor) {
  return Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

function formatarData(dataStr) {
  if (!dataStr) return "-";
  const d = new Date(dataStr);
  return d.toLocaleDateString("pt-BR") + " " + d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
}

function TabelaComprasWebloja({ idOrc }) {
  const [compras, setCompras] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    if (!idOrc) return;
    setCarregando(true);
    setErro(null);

    fetch(`${REQUEST_URL.replace("/mapavendas", "")}/webloja/compras/por-orcamento/${idOrc}`, {
      headers: { "x-api-key": WEBLOJA_API_KEY },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Erro ${res.status}`);
        return res.json();
      })
      .then((dados) => {
        setCompras(Array.isArray(dados) ? dados : []);
        setCarregando(false);
      })
      .catch((err) => {
        setErro("Não foi possível carregar as compras da webloja.");
        setCarregando(false);
        console.error("[TabelaComprasWebloja]", err);
      });
  }, [idOrc]);

  if (carregando) {
    return <p style={{ padding: 16, color: "#666" }}>Carregando compras da webloja...</p>;
  }

  if (erro) {
    return <p style={{ padding: 16, color: "#c0392b" }}>{erro}</p>;
  }

  if (compras.length === 0) {
    return (
      <p style={{ padding: 16, color: "#888" }}>
        Nenhuma compra realizada na webloja para este contrato.
      </p>
    );
  }

  const totalGeral = compras.reduce((acc, c) => acc + Number(c.total || 0), 0);

  const linhas = compras.flatMap((compra) =>
    (Array.isArray(compra.items) ? compra.items : []).map((item, idx) => ({
      ...item,
      orderCode: compra.orderCode,
      studentCpf: compra.studentCpf,
      createdAt: compra.createdAt,
      status: compra.status,
      _idx: idx,
      _compraId: compra.id,
    }))
  );

  return (
    <div style={{ marginTop: 8 }}>
      <strong style={{ fontSize: 13, color: "#495057" }}>Compras Webloja</strong>
      <div style={{ border: "1px solid #dee2e6", borderRadius: 6, overflow: "hidden", marginTop: 6 }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "#e9ecef" }}>
              <th style={{ padding: "6px 12px", textAlign: "left", fontWeight: 600 }}>Pedido</th>
              <th style={{ padding: "6px 12px", textAlign: "left", fontWeight: 600 }}>CPF</th>
              <th style={{ padding: "6px 12px", textAlign: "left", fontWeight: 600 }}>Data</th>
              <th style={{ padding: "6px 12px", textAlign: "left", fontWeight: 600 }}>Produto</th>
              <th style={{ padding: "6px 12px", textAlign: "center", fontWeight: 600 }}>Qtd</th>
              <th style={{ padding: "6px 12px", textAlign: "right", fontWeight: 600 }}>Unit.</th>
              <th style={{ padding: "6px 12px", textAlign: "right", fontWeight: 600 }}>Subtotal</th>
              <th style={{ padding: "6px 12px", textAlign: "center", fontWeight: 600 }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {linhas.map((linha, i) => (
              <tr key={`${linha._compraId}-${linha._idx}`} style={{ borderTop: "1px solid #dee2e6", background: i % 2 === 0 ? "#fff" : "#f8f9fa" }}>
                <td style={{ padding: "6px 12px", fontFamily: "monospace" }}>{linha._idx === 0 ? linha.orderCode : ""}</td>
                <td style={{ padding: "6px 12px" }}>{linha._idx === 0 ? (linha.studentCpf || "-") : ""}</td>
                <td style={{ padding: "6px 12px" }}>{linha._idx === 0 ? formatarData(linha.createdAt) : ""}</td>
                <td style={{ padding: "6px 12px" }}>{linha.name || "Produto"}</td>
                <td style={{ padding: "6px 12px", textAlign: "center" }}>{linha.quantity}</td>
                <td style={{ padding: "6px 12px", textAlign: "right" }}>{formatarMoeda(linha.price)}</td>
                <td style={{ padding: "6px 12px", textAlign: "right" }}>{formatarMoeda(linha.subtotal)}</td>
                <td style={{ padding: "6px 12px", textAlign: "center" }}>
                  {linha._idx === 0 ? (
                    <span style={{
                      background: linha.status === "pago" ? "#27ae60" : "#e67e22",
                      color: "#fff",
                      borderRadius: 12,
                      padding: "2px 10px",
                      fontSize: 11,
                      textTransform: "capitalize",
                    }}>
                      {linha.status}
                    </span>
                  ) : ""}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ borderTop: "2px solid #dee2e6", background: "#f8f9fa" }}>
              <td colSpan={7} style={{ padding: "8px 12px", textAlign: "right", fontWeight: 700 }}>
                Total geral:
              </td>
              <td style={{ padding: "8px 12px", textAlign: "right", fontWeight: 700, color: "#27ae60", whiteSpace: "nowrap" }}>
                {formatarMoeda(totalGeral)}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}

export { TabelaComprasWebloja };
